import { useNavigate } from 'react-router-dom';
import { Home } from '../pages/home/home';
import { useEffect } from 'react';
import { Examination } from '../pages/examination/examination';
import { ExaminationPaid } from '../pages/examination/examination-paid';
import { ExaminationTNC } from '../pages/examination/examination-tnc';
import { SingleFeed } from '../pages/home/components/single-feed';
// import { NoConnection } from '../pages/no-connection/no-connection';
import { Footer } from '../components/basic/footer';
import { Header } from '../components/basic/header';
import { MainContainer } from '../components/basic/main-container';
import { SignUp } from '../pages/auth/sign-up';
import { SignIn } from '../pages/auth/sign-in';
import { Booking } from '../pages/booking/booking';
import { DoctorsInExpertise } from '../pages/booking/expertise';
import { Notifications } from '../pages/notifications/notifications';
import { AboutUs } from '../pages/singles/about-us';
import { Logout } from '../pages/auth/logout';
import { MyVisits } from '../pages/visits/my-visits';
import { Profile } from './../pages/auth/profile';
import { ExaminationStart } from '../pages/examination/examination-start/examination-start';
import { Suggestions } from '../pages/booking/suggestions';
import { ExaminationList } from '../pages/examination/examination-list/examination-list';
import { ExaminationDetail } from '../pages/examination/examination-list/examination-details';
import { Reserve } from '../pages/booking/reserve';
import { SplashPage } from '../components/basic/splash';
import { TnC } from '../pages/singles/tnc';
import { Feedback } from '../pages/singles/feedback';
import { Support } from '../pages/singles/support';
interface Props {
  name: string;
}

const Dummy = ({ name }: Props) => <p className="text-center">{name}</p>;
const CustomNavigator = ({ to }: { to: string }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(to);
  }, []);
  return <></>;
};

// todo fix back button
const PAGES = {
  feed: {
    title: 'خانه',
    lastPage: false
  },
  singleFeed: {
    title: 'جزئیات پست',
    lastPage: true
  },
  examination: {
    title: 'بخش معاینه',
    lastPage: false
  },
  expertise: {
    title: 'رزرو نوبت ویزیت',
    lastPage: false
  },
  expertiseList: {
    title: 'دریافت نوبت از پزشکان',
    lastPage: false
  },
  notifications: {
    title: 'پیام های ذخیره شده',
    lastPage: true
  },
  aboutus: {
    title: 'درباره ما',
    lastPage: true
  },
  signUp: {
    title: 'MedMe',
    lastPage: true
  },
  login: {
    title: 'MedMe',
    lastPage: true
  },
  examinationStart: {
    title: 'تشخیص طبی',
    lastPage: true,
    backTo: '/examination',
    showModal: true
  },
  suggestion: {
    title: 'پیشنهاد ویزیت متخصص',
    lastPage: true
  },
  examinationsList: {
    title: 'معاینات من',
    lastPage: false
  },
  payment: {
    title: 'پرداخت',
    lastPage: true
  },
  payment2: {
    title: 'پرداخت',
    lastPage: false
  },
  visits: {
    title: 'نوبت های من',
    lastPage: false
  },
  reserve: {
    title: 'رزرو وقت',
    lastPage: true
  },
  tnc: {
    title: 'قوانین و سیاست حفظ حریم خصوصی',
    lastPage: true
  },
  feedback: {
    title: 'ثبت نظر درمورد برنامه',
    lastPage: true
  },
  support: {
    title: 'پشتیبانی',
    lastPage: true
  },
  temp: {
    title: '',
    lastPage: false
  },
  fof: {
    title: 'یافت نشد',
    lastPage: false
  }
};

interface LayoutProps {
  children: React.ReactNode;
  options: {
    title: string;
    lastPage: boolean;
    backTo?: string;
    showModal?: boolean;
  };
}
const Layout = (props: LayoutProps) => (
  <div className="max-w-[500px] mx-auto bg-[#fff] relative">
    <Header
      title={props.options.title}
      lastPage={props.options.lastPage}
      backTo={props.options?.backTo}
      showModal={props.options?.showModal}
    />
    <MainContainer>{props.children}</MainContainer>
    <Footer />
  </div>
);

export const routes = (isPing: boolean) => [
  {
    path: '/',
    element: <CustomNavigator to="/feed" />
  },
  {
    path: '/feed',
    element: isPing ? (
      <Layout options={PAGES.feed}>
        <Home />
      </Layout>
    ) : (
      <SplashPage connected={false} />
    )
  },
  {
    path: '/reserve/:id',
    element: (
      <Layout options={PAGES.reserve}>
        <Reserve />
      </Layout>
    )
  },
  {
    path: '/my-visits',
    element: (
      <Layout options={PAGES.visits}>
        <MyVisits />
      </Layout>
    )
  },
  {
    path: '/profile',
    element: (
      <Layout options={PAGES.signUp}>
        <Profile />
      </Layout>
    )
  },
  {
    path: '/feed/:id',
    element: (
      <Layout options={PAGES.singleFeed}>
        <SingleFeed />
      </Layout>
    )
  },
  {
    path: '/auth/sign-up',
    element: (
      <Layout options={PAGES.signUp}>
        <SignUp />
      </Layout>
    )
  },
  {
    path: '/auth/sign-in',
    element: (
      <Layout options={PAGES.signUp}>
        <SignIn />
      </Layout>
    )
  },
  {
    path: '/logout',
    element: (
      <Layout options={PAGES.temp}>
        <Logout />
      </Layout>
    )
  },
  {
    path: '/expertise',
    element: (
      <Layout options={PAGES.expertiseList}>
        <Booking />
      </Layout>
    )
  },
  {
    path: '/expertise/:id',
    element: (
      <Layout options={PAGES.expertise}>
        <DoctorsInExpertise />
      </Layout>
    )
  },
  {
    path: '/examination',
    element: (
      <Layout options={PAGES.examination}>
        <Examination />
      </Layout>
    )
  },
  {
    path: '/examinations',
    element: (
      <Layout options={PAGES.examinationsList}>
        <ExaminationList />
      </Layout>
    )
  },
  {
    path: '/examination/paid',
    element: (
      <Layout options={PAGES.payment}>
        <ExaminationPaid isAfterPaid={false} />
      </Layout>
    )
  },
  {
    path: '/examination/after-paid',
    element: (
      <Layout options={PAGES.payment2}>
        <ExaminationPaid isAfterPaid={true} />
      </Layout>
    )
  },
  {
    path: '/examination/tnc',
    element: (
      <Layout options={PAGES.payment}>
        <ExaminationTNC />
      </Layout>
    )
  },
  {
    path: '/examination/start/des_t/:productId/:invoiceId/:refNumber/:diagnosisId',
    element: (
      <Layout options={PAGES.examinationStart}>
        <ExaminationStart type="des_t" />
      </Layout>
    )
  },
  {
    path: '/examination/start/score/:productId/:invoiceId/:refNumber/:diagnosisId',
    element: (
      <Layout options={PAGES.examinationStart}>
        <ExaminationStart type="score" />
      </Layout>
    )
  },
  {
    path: '/suggestions/:productId/:endVertexId',
    element: (
      <Layout options={PAGES.suggestion}>
        <Suggestions />
      </Layout>
    )
  },
  {
    path: '/diagnosis/:id/:productId',
    element: (
      <Layout options={PAGES.suggestion}>
        <ExaminationDetail />
      </Layout>
    )
  },
  {
    path: '/notifications',
    element: (
      <Layout options={PAGES.notifications}>
        <Notifications />
      </Layout>
    )
  },
  {
    path: '/about-us',
    element: (
      <Layout options={PAGES.aboutus}>
        <AboutUs />
      </Layout>
    )
  },
  {
    path: '/tnc',
    element: (
      <Layout options={PAGES.tnc}>
        <TnC />
      </Layout>
    )
  },
  {
    path: '/feedback',
    element: (
      <Layout options={PAGES.feedback}>
        <Feedback />
      </Layout>
    )
  },
  {
    path: '/support',
    element: (
      <Layout options={PAGES.support}>
        <Support />
      </Layout>
    )
  },
  {
    path: '*',
    element: (
      <Layout options={PAGES.fof}>
        <Dummy name="404" />
      </Layout>
    )
  }
];
